import { Link, NavLink, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { LogOut, User, Radio } from "lucide-react";

const navItem = ({ isActive }) =>
  `font-mono-head text-xs uppercase tracking-[0.2em] px-3 py-2 transition-colors ${
    isActive ? "text-[#E60000] border-b-2 border-[#E60000]" : "text-stone-700 hover:text-stone-900"
  }`;

export default function Header() {
  const { user, logout } = useAuth();
  const nav = useNavigate();

  return (
    <header className="border-b-2 border-stone-900 bg-stone-50 sticky top-0 z-40">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-3 flex items-center justify-between gap-4">
        <Link to="/" data-testid="header-logo" className="flex items-center gap-2 group">
          <Radio className="w-5 h-5 text-[#E60000] group-hover:rotate-12 transition-transform" strokeWidth={2.5} />
          <div className="leading-none">
            <div className="font-serif-head text-xl text-stone-900">Hot Truth Archive</div>
            <div className="font-mono-head text-[9px] uppercase tracking-[0.3em] text-stone-500 mt-0.5">
              Investigative · Signals · Sources
            </div>
          </div>
        </Link>

        <nav className="hidden md:flex items-center gap-1">
          <NavLink to="/" end className={navItem} data-testid="nav-feed">Feed</NavLink>
          <NavLink to="/topics" className={navItem} data-testid="nav-topics">Topics</NavLink>
          <NavLink to="/disagreement" className={navItem} data-testid="nav-disagreement">Disagreement</NavLink>
          <NavLink to="/archive" className={navItem} data-testid="nav-archive">Archive</NavLink>
          {user && (
            <NavLink to="/bookmarks" className={navItem} data-testid="nav-bookmarks">Bookmarks</NavLink>
          )}
        </nav>

        <div className="flex items-center gap-2">
          {user ? (
            <>
              <span className="hidden sm:inline font-mono-head text-xs uppercase tracking-widest text-stone-600">
                <User className="w-3 h-3 inline mr-1" /> {user.name}
              </span>
              <button
                data-testid="logout-btn"
                onClick={() => { logout(); nav("/"); }}
                className="font-mono-head text-xs uppercase tracking-widest border border-stone-900 px-3 py-2 hover:bg-stone-900 hover:text-stone-50 transition-colors flex items-center gap-1"
              >
                <LogOut className="w-3 h-3" /> Logout
              </button>
            </>
          ) : (
            <>
              <Link
                to="/login"
                data-testid="nav-login"
                className="font-mono-head text-xs uppercase tracking-widest text-stone-700 hover:text-stone-900 px-3 py-2"
              >
                Login
              </Link>
              <Link
                to="/register"
                data-testid="nav-register"
                className="font-mono-head text-xs uppercase tracking-widest bg-stone-900 text-stone-50 px-4 py-2 hover:bg-[#E60000] transition-colors"
              >
                Register
              </Link>
            </>
          )}
        </div>
      </div>
      <div className="marquee-line" />
    </header>
  );
}
